import { useRouteError } from 'react-router-dom'
import { usePageTitle } from '@/hooks/usePageTitle'

/**
 * Port of Views/Shared/Error.cshtml.
 *
 * The original printed a Request ID and three paragraphs about enabling the
 * Development environment — deployment advice aimed at a developer that every
 * candidate saw on a failed page. The user-facing text is kept; the
 * environment lecture is not, and the underlying error goes to the console
 * rather than the page.
 */
export function ErrorPage(): JSX.Element {
  const error = useRouteError()
  usePageTitle('Error')

  if (error) console.error('Route error:', error)

  return (
    <div className="container py-5">
      <h1 className="text-danger">Error.</h1>
      <h2 className="text-danger">An error occurred while processing your request.</h2>
      <p className="mt-4">
        <a href="/" className="btn btn-primary">
          Back to home
        </a>
      </p>
    </div>
  )
}
